import React, { useState, useEffect } from 'react'
import "./ordermgmt.css";
import "./invoice.css";
import { Modal, Dropdown } from 'react-bootstrap';
import Papa from 'papaparse';
import { PDFDocument, rgb } from 'pdf-lib'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToWords } from 'to-words';
import html2pdf from 'html2pdf.js'
const Ordermgmt = () => {
  // --- Update Status Modal State ---
  const [updateStatusModal, setUpdateStatusModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [selectedOrderStatus, setSelectedOrderStatus] = useState('');
  const [statusUpdating, setStatusUpdating] = useState(false);

  // Handles opening the modal for a given order
  const handleOpenUpdateStatus = (orderId) => {
    setSelectedOrderId(orderId);
    setSelectedOrderStatus('');
    setUpdateStatusModal(true);
  };

  // Handles closing the modal
  const handleCloseUpdateStatus = () => {
    setSelectedOrderId(null);
    setSelectedOrderStatus('');
    setUpdateStatusModal(false);
  };

  // Handles submitting the status update
  const handleSubmitStatusUpdate = async () => {
    if (!selectedOrderId || !selectedOrderStatus) {
      toast.error('Please select a status.');
      return;
    }
    setStatusUpdating(true);
    try {
      // Replace with your actual API endpoint and method
      const response = await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminUpdateMainStatus`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
        body: JSON.stringify({ OrderId: selectedOrderId, OrderStatus: selectedOrderStatus })
      });
      if (!response.ok) throw new Error('Failed to update status');
      toast.success('Order status updated successfully!');
      setUpdateStatusModal(false);
      setSelectedOrderId(null);
      setSelectedOrderStatus('');
      // Fetch data again to refresh UI
      getreceivedorder();
    } catch (err) {
      toast.error('Error updating order status.');
    }
    setStatusUpdating(false);
  };

  const [modalShow1, setModalShow1] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [modalShow3, setModalShow3] = useState(false);
  const [modalShow4, setModalShow4] = useState(false);
  const [userData, setuserData] = useState({})
  const [orderData, setorderData] = useState({})
  const [index, setindex] = useState(0)
  const statesArray = [
    { code: 1, name: "JAMMU & KASHMIR" },
    { code: 2, name: "HIMACHAL PRADESH" },
    { code: 3, name: "PUNJAB" },
    { code: 4, name: "CHANDIGARH" },
    { code: 5, name: "UTTARAKHAND" },
    { code: 6, name: "HARYANA" },
    { code: 7, name: "DELHI" },
    { code: 8, name: "RAJASTHAN" },
    { code: 9, name: "UTTAR PRADESH" },
    { code: 10, name: "BIHAR" },
    { code: 11, name: "SIKKIM" },
    { code: 12, name: "ARUNACHAL PRADESH" },
    { code: 13, name: "NAGALAND" },
    { code: 14, name: "MANIPUR" },
    { code: 15, name: "MIZORAM" },
    { code: 16, name: "TRIPURA" },
    { code: 17, name: "MEGHALAYA" },
    { code: 18, name: "ASSAM" },
    { code: 19, name: "WEST BENGAL" },
    { code: 20, name: "JHARKHAND" },
    { code: 21, name: "ORISSA" },
    { code: 22, name: "CHHATTISGARH" },
    { code: 23, name: "MADHYA PRADESH" },
    { code: 24, name: "GUJARAT" },
    { code: 25, name: "DAMAN AND DIU" },
    { code: 26, name: "DADAR AND NAGAR HAVELI" },
    { code: 27, name: "MAHARASHTRA" },
    { code: 29, name: "KARNATAKA" },
    { code: 30, name: "GOA" },
    { code: 31, name: "LAKSHADWEEP" },
    { code: 32, name: "KERALA" },
    { code: 33, name: "TAMIL NADU" },
    { code: 34, name: "PUDUCHERRY" },
    { code: 35, name: "ANDAMAN AND NICOBAR" },
    { code: 36, name: "TELANGANA" },
    { code: 37, name: "ANDHRA PRADESH" },
    { code: 97, name: "OTHER TERRITORY" }
  ];
  const [searchvalue, setsearchvalue] = useState("")
  const [order, setorder] = useState([])
  const [originalOrder, setoriginalOrder] = useState([]) // Store original data
  const [startDate, setstartDate] = useState("")
  const [endDate, setendDate] = useState("")
  const [startTime, setstartTime] = useState("")
  const [endTime, setendTime] = useState("")
  const [paymentMode, setpaymentMode] = useState("")
  const [id, setId] = useState(0)
  const [invoice, setinvoice] = useState({})
  const toWords = new ToWords();
  function getCodeByStateName(stateName) {
    const stateObject = statesArray?.find(state => state?.name === stateName?.toUpperCase());
    return stateObject ? stateObject?.name : null;
  }

  const getreceivedorder = async () => {
    try {
      await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminGetShippedOrder`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        }
      }).then((res) => res.json()).then((response) => {
        if (response.status === 200) {
          setorder(response.data)
          setoriginalOrder(response.data) // Store original data for reset

        } else {
          toast.error("No Order Found")

        }
      })
    } catch (error) {
      console.error('API Error:', error);
    }

  }
  useEffect(() => {
    getreceivedorder()
  }, [])
  function daysLeftToNextTwoYearsFromDate(startDate) {
    // Convert the start date string to a Date object
    const startDateObj = new Date(startDate);

    // Calculate the end date of the warranty period (2 years from the start date)
    const warrantyEndDate = new Date(startDateObj);
    warrantyEndDate.setFullYear(startDateObj.getFullYear() + 4);

    // Calculate the difference in days
    const daysDifference = Math.ceil((warrantyEndDate - new Date()) / (1000 * 60 * 60 * 24));

    return daysDifference;
  }
  const convertToCSV = (data) => {


    const transformedData = data.map((item) => {
      let totalQuantity = 0;
      let totalSubTotal = 0;
      item.OrderDetail.forEach((orderDetailItem) => {
        totalQuantity += parseInt(orderDetailItem.OrderQuantity);
        totalSubTotal += parseInt(orderDetailItem.OrderSubTotal);
      });
      return (
        {
          "Order ID": item.OrderId,
          "Product Name": item.OrderDetail[0].OrderName + (item.OrderDetail.length > 1 ? "+ " + parseInt(item.OrderDetail.length - 1) : ""),
          "Buyer": item.OrderAddress?.[0]?.Phone.replace('+91', ''),
          "Date": item.OrderDate.split(" ")[0],
          "Time": item.OrderDate.split(" ")[1],
          "Quantity": totalQuantity,
          "Payment": item.OrderPaymentType,
          "Amount": totalSubTotal,
          "Discount": item.OrderCoupanPrice,
          "GST No.": item.OrderGST,
          "Invoice No.": item.InvoiceNumber,
          "State/UT Name": getCodeByStateName(item.OrderAddress?.[0]?.State.toUpperCase()),
          "Status": item.OrderStatus === "Order Confirmed" ? "Order Confirmed" : item.OrderStatus === "Shipped" ? "Shipped" : item.OrderStatus === "Delivered" ? "Delivered" : item.OrderStatus === "Cancelled" ? "Cancelled" : item.OrderStatus === "RTO" ? "Denied" : "",
        })
    });

    // Generate CSV from transformed data
    const csv = Papa.unparse(transformedData, {
      header: true, // Include headers in CSV
    });

    return csv;
  };
  const downloadCSV = (csvData, fileName) => {
    const blob = new Blob([csvData], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleExportCSV = () => {
    // Export only the currently filtered/displayed data
    const csvData = convertToCSV(order);
    downloadCSV(csvData, 'order_data.csv');
  };



  const print = async () => {
    const elementToCapture = document.getElementById('invoiceprint');

    // Use html2pdf to convert the element to a PDF
    await html2pdf(elementToCapture)
      .then(pdf => {
        // You can then save the PDF or perform other actions
        // For example, to save the PDF:
        pdf.save("invoice.pdf");
        setModalShow2(false);
      })
      .catch(error => {
        console.error('Error converting element to PDF:', error);
      });
  }



  const showinvoice = (id) => {
    const index = order.findIndex((item) => item.OrderId === id);
    setId(index)
    setModalShow2(true)
    let totalamount = 0;
    for (let i = 0; i < order[index].OrderDetail.length; i++) {
      totalamount += parseInt(order[index].OrderDetail[i].OrderSubTotal)
    }
    setinvoice({
      totalamount: totalamount,
    })
  }

  const search = async () => {
    if (searchvalue.length > 0) {
      const filteredData = originalOrder.filter((item) => {
        const orderId = item.OrderId;
        const phone = item.UserPhone;
        const type = item.OrderPaymentType;

        return orderId.includes(searchvalue) || phone.includes(searchvalue) || type.includes(searchvalue)
      })
      setorder(filteredData)
      setCurrentPage(1)
    } else {
      // Reset to original data when search input is empty
      setorder(originalOrder)
      setCurrentPage(1)
    }
  }

  const status = async (status) => {
    // Start with original data or filtered by search if search is active
    let dataToFilter = [...originalOrder];
    
    // Apply search filter if there's a search value
    if (searchvalue.length > 0) {
      dataToFilter = dataToFilter.filter((item) => {
        const orderId = item.OrderId;
        const phone = item.UserPhone;
        const type = item.OrderPaymentType;
        return orderId.includes(searchvalue) || phone.includes(searchvalue) || type.includes(searchvalue)
      });
    }
    
    if (status === "Shipped") {
      const filteredData = dataToFilter.filter((item) => {
        return item.OrderStatus === "Shipped"
      })
      setorder(filteredData)
    } else if (status === "Delivered") {
      const filteredData = dataToFilter.filter((item) => {
        return item.OrderStatus === "Delivered"
      })
      setorder(filteredData)
    } else if (status === "Cancelled") {
      const filteredData = dataToFilter.filter((item) => {
        return item.OrderStatus === "Cancelled"
      })
      setorder(filteredData)
    } else if (status === "Order Confirmed") {
      const filteredData = dataToFilter.filter((item) => {
        return item.OrderStatus === "Order Confirmed"
      })
      setorder(filteredData)
    }
    else if (status === "IN TRANSIT") {
      const filteredData = dataToFilter.filter((item) => {
        return item.OrderStatus === "IN TRANSIT"
      })
      setorder(filteredData)
    } else if (status === "RTO") {
      const filteredData = dataToFilter.filter((item) => {
        return item.OrderStatus === "RTO"
      })
      setorder(filteredData)
    } else {
      // Reset to original data or filtered by search
      if (searchvalue.length > 0) {
        search();
      } else {
        setorder(originalOrder)
      }
    }
    setCurrentPage(1)
  }

  const filter = async () => {
    // Start with original data or filtered by search if search is active
    let dataToFilter = searchvalue.length > 0 ? 
      originalOrder.filter((item) => {
        const orderId = item.OrderId;
        const phone = item.UserPhone;
        const type = item.OrderPaymentType;
        return orderId.includes(searchvalue) || phone.includes(searchvalue) || type.includes(searchvalue)
      }) : 
      [...originalOrder];

    const filteredData = dataToFilter.filter((item) => {
      const orderDate = item.OrderDate.split(" ")[0];
      const orderTime = item.OrderDate.split(" ")[1];
      const payment = item.OrderPaymentType;
      var dateString = orderDate;

      // Split the date string into day, month, and year
      var dateParts = dateString.split("-");
      var day = parseInt(dateParts[0], 10);
      var month = parseInt(dateParts[1], 10) - 1; // Adjust month (0-indexed in JavaScript)
      var year = parseInt(dateParts[2], 10);

      // Create a new Date object with the parsed values
      var myDate = new Date(year, month, day);

      if (startDate.length > 0 && endDate.length > 0 && startTime.length > 0 && endTime.length > 0 && paymentMode.length > 0) {
        return myDate >= new Date(startDate) && myDate <= new Date(endDate) && orderTime >= startTime && orderTime <= endTime && payment.includes(paymentMode)
      } else if (startDate.length > 0 && endDate.length > 0 && startTime.length > 0 && endTime.length > 0 && paymentMode.length === 0) {
        return myDate >= new Date(startDate) && myDate <= new Date(endDate) && orderTime >= startTime && orderTime <= endTime
      } else if (startDate.length > 0 && endDate.length > 0 && startTime.length > 0 && endTime.length === 0 && paymentMode.length > 0) {
        return myDate >= new Date(startDate) && myDate <= new Date(endDate) && orderTime >= startTime && payment.includes(paymentMode)
      } else if (startDate.length > 0 && endDate.length > 0 && startTime.length > 0 && endTime.length === 0 && paymentMode.length === 0) {
        return myDate >= new Date(startDate) && myDate <= new Date(endDate) && orderTime >= startTime
      } else if (startDate.length > 0 && endDate.length > 0 && startTime.length === 0 && endTime.length > 0 && paymentMode.length > 0) {
        return myDate >= new Date(startDate) && myDate <= new Date(endDate) && orderTime <= endTime && payment.includes(paymentMode)
      } else if (startDate.length > 0 && endDate.length > 0 && startTime.length === 0 && endTime.length > 0 && paymentMode.length === 0) {
        return myDate >= new Date(startDate) && myDate <= new Date(endDate) && orderTime <= endTime
      } else if (startDate.length > 0 && endDate.length > 0 && startTime.length === 0 && endTime.length === 0 && paymentMode.length > 0) {
        return myDate >= new Date(startDate) && myDate <= new Date(endDate) && payment.includes(paymentMode)
      } else if (startDate.length > 0 && endDate.length > 0 && startTime.length === 0 && endTime.length === 0 && paymentMode.length === 0) {
        return myDate >= new Date(startDate) && myDate <= new Date(endDate)
      } else if (startDate.length > 0 && endDate.length === 0 && startTime.length > 0 && endTime.length > 0 && paymentMode.length > 0) {
        return myDate >= new Date(startDate) && orderTime >= startTime && orderTime <= endTime && payment.includes(paymentMode)
      } else if (startDate.length > 0 && endDate.length === 0 && startTime.length > 0 && endTime.length > 0 && paymentMode.length === 0) {
        return myDate >= new Date(startDate) && orderTime >= startTime && orderTime <= endTime
      } else if (startDate.length > 0 && endDate.length === 0 && startTime.length > 0 && endTime.length === 0 && paymentMode.length > 0) {
        return myDate >= new Date(startDate) && orderTime >= startTime && payment.includes(paymentMode)
      } else if (startDate.length > 0 && endDate.length === 0 && startTime.length > 0 && endTime.length === 0 && paymentMode.length === 0) {
        return myDate >= new Date(startDate) && orderTime >= startTime
      } else if (startDate.length > 0 && endDate.length === 0 && startTime.length === 0 && endTime.length > 0 && paymentMode.length > 0) {
        return myDate >= new Date(startDate) && orderTime <= endTime && payment.includes(paymentMode)
      } else if (startDate.length > 0 && endDate.length === 0 && startTime.length === 0 && endTime.length > 0 && paymentMode.length === 0) {
        return myDate >= new Date(startDate) && orderTime <= endTime
      } else if (startDate.length > 0 && endDate.length === 0 && startTime.length === 0 && endTime.length === 0 && paymentMode.length > 0) {
        return myDate >= new Date(startDate) && payment.includes(paymentMode)
      } else if (startDate.length > 0 && endDate.length === 0 && startTime.length === 0 && endTime.length === 0 && paymentMode.length === 0) {
        return myDate >= new Date(startDate)
      } else if (startDate.length === 0 && endDate.length > 0 && startTime.length > 0 && endTime.length > 0 && paymentMode.length > 0) {
        return myDate <= new Date(endDate) && orderTime >= startTime && orderTime <= endTime && payment.includes(paymentMode)
      } else if (startDate.length === 0 && endDate.length > 0 && startTime.length > 0 && endTime.length > 0 && paymentMode.length === 0) {
        return myDate <= new Date(endDate) && orderTime >= startTime && orderTime <= endTime
      } else if (startDate.length === 0 && endDate.length > 0 && startTime.length > 0 && endTime.length === 0 && paymentMode.length > 0) {
        return myDate <= new Date(endDate) && orderTime >= startTime && payment.includes(paymentMode)
      } else if (startDate.length === 0 && endDate.length > 0 && startTime.length > 0 && endTime.length === 0 && paymentMode.length === 0) {
        return myDate <= new Date(endDate) && orderTime >= startTime
      } else if (startDate.length === 0 && endDate.length > 0 && startTime.length === 0 && endTime.length > 0 && paymentMode.length > 0) {
        return myDate <= new Date(endDate) && orderTime <= endTime && payment.includes(paymentMode)
      } else if (startDate.length === 0 && endDate.length > 0 && startTime.length === 0 && endTime.length > 0 && paymentMode.length === 0) {
        return myDate <= new Date(endDate) && orderTime <= endTime
      } else if (startDate.length === 0 && endDate.length > 0 && startTime.length === 0 && endTime.length === 0 && paymentMode.length > 0) {
        return myDate <= new Date(endDate) && payment.includes(paymentMode)
      } else if (startDate.length === 0 && endDate.length > 0 && startTime.length === 0 && endTime.length === 0 && paymentMode.length === 0) {
        return myDate <= new Date(endDate)
      } else if (startDate.length === 0 && endDate.length === 0 && startTime.length === 0 && endTime.length === 0 && paymentMode.length > 0) {
        return payment.includes(paymentMode)
      } else if (startDate.length === 0 && endDate.length === 0 && startTime.length > 0 && endTime.length === 0 && paymentMode.length === 0) {
        return orderTime >= startTime
      } else if (startDate.length === 0 && endDate.length === 0 && startTime.length === 0 && endTime.length > 0 && paymentMode.length === 0) {
        return orderTime <= endTime

      } else if (startDate.length === 0 && endDate.length === 0 && startTime.length > 0 && endTime.length > 0 && paymentMode.length === 0) {
        return orderTime >= startTime && orderTime <= endTime
      } else {
        return true
      }
    }
    )
    setorder(filteredData)
    setModalShow1(false);
    setstartDate("");
    setendDate("");
    setstartTime("");
    setendTime("");
    setpaymentMode("");

  }

  const getUserdetail = async (id) => {
    try {

      const index = order.findIndex((item) => item.OrderId === id);
      await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotGetUserDetail`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          UserId: order[index].UserId
        })
      }).then((res) => res.json()).then((response) => {
        if (response.status === 200) {

          setModalShow3(true);
          setindex(index)
          setuserData(response.data)
        } else {
          toast.error("No User Detail Found")
        }
      })
    }

    catch (error) {
      console.error('API Error:', error);
    }
  }
  const getOrderdetail = async (id) => {
    try {
      const index = order.findIndex((item) => item.OrderId === id);
      await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotGetOrderDetail`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          OrderId: order[index].OrderId
        })
      }).then((res) => res.json()).then((response) => {
        if (response.status === 200) {

          setModalShow4(true);
          setindex(index)
          setorderData(response.data)
        } else {
          toast.error("No Order Detail Found")
        }
      })
    }

    catch (error) {
      console.error('API Error:', error);
    }
  }
  function calculateFinalAmount(invoice, order, id) {
    // Extract values for better readability
    const totalAmount = Number(invoice?.totalamount);
    const orderCouponPrice = Number(order[id]?.OrderCoupanPrice);


    // Calculate the discount without tax
    const discountWithoutTax = totalAmount - orderCouponPrice;


    // Calculate the tax amount (18% in this case)
    const taxAmount = discountWithoutTax - (discountWithoutTax / 1.18);


    // Calculate the final amount
    const finalAmount = (discountWithoutTax / 1.18 + taxAmount).toFixed(2);

    return finalAmount;
  }
  function calculateTaxAmount(invoice, order, id) {
    // Extract values for better readability
    const totalAmount = Number(invoice?.totalamount);
    const orderCouponPrice = Number(order[id]?.OrderCoupanPrice);


    // Calculate the discount without tax
    const discountWithoutTax = totalAmount - orderCouponPrice;


    // Calculate the tax amount (18% in this case)
    const taxAmount = discountWithoutTax - (discountWithoutTax / 1.18);





    return taxAmount;
  }

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20); // Change as per your requirement

  // Get current items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = order.slice(indexOfFirstItem, indexOfLastItem);

  // Change page
  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getHsCode = (item) => {
    const currentDate = new Date();
    const financialYearStart = new Date(2025, 3, 1); // April 1, 2025
  
    if (currentDate < financialYearStart) {
      return "84145120";
    }
  
    const orderName = item.OrderName?.toLowerCase() || "";
  
    if (orderName.includes("fan")) return "84145120";
    if (orderName.includes("exhaust")) return "841451";
    if (orderName.includes("led")) return "853950";
    if (orderName.includes("recharge")) return "851310";
  
    return "84145120";
  };
  const refreshData = async () => {
    // Clear search input
    setsearchvalue("");
    // Reset to original data from API
    await getreceivedorder();
    // Reset page
    setCurrentPage(1);
    // Reset filter values
    setstartDate("");
    setendDate("");
    setstartTime("");
    setendTime("");
    setpaymentMode("");
    toast.success("Data refreshed successfully");
  }
  function daysLeftToNextThreeYearsFromDate(startDate) {
    // Convert the start date string to a Date object
    const startDateObj = new Date(startDate);


    // Calculate the end date of the warranty period (2 years from the start date)
    const warrantyEndDate = new Date(startDateObj);
    warrantyEndDate.setFullYear(startDateObj.getFullYear() + 3);

    // Calculate the difference in days
    const daysDifference = Math.ceil((warrantyEndDate - new Date()) / (1000 * 60 * 60 * 24));

    return daysDifference;
  }
  return (
    <>
      <section className="dashbg-color">

        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="admin-filters">

              <div className="search-bar">
                <div className="search-container">
                  
                    <input type="text" placeholder="Search by- OrderId, Phone" name="search" value={searchvalue} onChange={(e) => {
                      setsearchvalue(e.target.value)
                      // Auto-reset when input is cleared
                      if (e.target.value === '') {
                        setorder(originalOrder)
                        setCurrentPage(1)
                      }
                    }} />
                    <button type="button" onClick={() => {
                      search()
                    }}><i className="fa fa-search"></i></button>
                 
                </div>
              </div>

              <div className="filters d-flex">
                <button className="btn filter-pop" onClick={() => {
                  setModalShow1(true);
                }}>Filters <i className="fa fa-filter"></i></button>
                <Dropdown className="d-inline mx-2">
                  <Dropdown.Toggle id="dropdown-autoclose-true" className="btn filter-pop"  >Status <i className="fa fa-angle-down"></i>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => { status("All") }}>All</Dropdown.Item>
                    <Dropdown.Item onClick={() => {
                      status("Order Confirmed")
                    }}>Order Confirmed</Dropdown.Item>
                    <Dropdown.Item onClick={() => {
                      status("Shipped")
                    }}>Shipped</Dropdown.Item>
                      <Dropdown.Item onClick={() => {
                      status("IN TRANSIT")
                    }}>Picked Up</Dropdown.Item>
                    <Dropdown.Item onClick={() => {
                      status("Delivered")
                    }}>Delivery </Dropdown.Item>
                    <Dropdown.Item onClick={() => {
                      status("Cancelled")
                    }}>Cancelled</Dropdown.Item>
                    <Dropdown.Item onClick={() => {
                      status("RTO")
                    }}>Denied</Dropdown.Item>

                  </Dropdown.Menu>
                </Dropdown>

                <button className="btn Export-btn filter-pop" onClick={() => {
                  handleExportCSV();
                  toast.success("CSV downloaded successfully")
                }}>Export CSV <i className='fas fa-file-export'></i></button>
                
                <button className="btn filter-pop ml-2" style={{ backgroundColor: "white", color: "#4CAF50", borderColor:"#4CAF50" }} onClick={refreshData}>
                  <i className="fas fa-sync-alt"></i>
                </button>
              </div>

            </div>
          </div>

        </div>

        <div className="row justify-content-center">

          <div className="col-lg-12 table-bg">
            <div style={{ backgroundColor: "white" }}>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">S.No.</th>
                      <th scope="col">Order ID</th>
                      <th scope="col">Product Name</th>
                      <th scope="col">Buyer</th>
                      <th scope="col">Date</th>
                      <th scope="col">Time</th>
                      <th scope="col">Quantity</th>
                      <th scope="col">Payment</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Discount</th>
                      <th scope="col">GST No.</th>
                      <th scope="col">Invoice No.</th>
                      <th scope="col">State/UT Name</th>
                      <th scope="col">Status</th>
                      <th scope="col">Invoice</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.length > 0 && currentItems.map((item, index) => {
  const eligibleStatuses = ["Pending", "RTO", "Delivered", "Cancelled", "Order Confirmed"];

                      let totalQuantity = 0;
                      let totalSubTotal = 0;


                      item.OrderDetail.forEach((orderDetailItem) => {
                        totalQuantity += parseInt(orderDetailItem.OrderQuantity);
                        totalSubTotal += parseInt(orderDetailItem.OrderSubTotal);

                      });

                      return (
                        <tr key={index}>
                          <th scope="row">{order.length - ((currentPage - 1) * itemsPerPage + index)}</th>
                          <td><span className='navcolor' onClick={() => {
                            getOrderdetail(item.OrderId)
                          }}>{item.OrderId}</span></td>
                          <td>{item.OrderDetail[0].OrderName} {item.OrderDetail.length > 1 ? "+ " + parseInt(item.OrderDetail.length - 1) : ""}</td>
                          <td><span className='navcolor' onClick={() => {
                            getUserdetail(item.OrderId)
                          }}>{item.UserPhone}</span></td>
                          <td>{item.OrderDate.split(" ")[0]}</td>

                          <td>{item.OrderDate.split(" ")[1]}</td>
                          <td>{totalQuantity}</td>
                          <td>{item.OrderPaymentType}</td>
                          <td>{totalSubTotal - parseInt(item.OrderCoupanPrice)}</td>
                          <td>{parseInt(item.OrderCoupanPrice)}</td>
                          <td>{item?.OrderGST}</td>
                          <td>{item?.InvoiceNumber}</td>
                          <td>{getCodeByStateName(item?.OrderAddress[0]?.State.toUpperCase())}</td>
                          <td className='statustd'>
  {item.OrderStatus === "Pending" ? <p className="text-warning">Pending</p> : ""}
  {item.OrderStatus === "Order Confirmed" ? <p className="text-info">Order Confirmed</p> : ""}
  {item.OrderStatus === "Shipped" ? <p className="text-warning">Shipped</p> : ""}
  {item.OrderStatus === "IN TRANSIT" ? <p className="text-info">Picked Up</p> : ""}
  {item.OrderStatus === "Delivered" ? <p className="text-success">Delivered</p> : ""}
  {item.OrderStatus === "Cancelled" ? <p className="text-danger">Cancelled</p> : ""}
  {item.OrderStatus === "RTO" ? <p className="text-danger">Denied</p> : ""}
  {/* Update Status Button */}
  {!eligibleStatuses.includes(item.OrderStatus) && (
    <button className="btn  btn-primary btn-sm mt-2" onClick={() => handleOpenUpdateStatus(item.OrderId)}>
      Update Status
    </button>
  )}
</td>
                          <td>{item.OrderStatus === "Pending"?"":<button className="btn received-btn" disabled={item.OrderStatus === "Cancelled" || item?.InvoiceNumber === "" ? true : false} onClick={() => {
                            showinvoice(item.OrderId)
                          }}>Print </button>}
                          </td>
                        </tr>
                      )
                    })}
                    {currentItems.length === 0 && <tr>
                      <td colSpan="15" className="text-center">No Order Found</td>
                    </tr>}


                  </tbody>
                </table>
              </div>

              <div className="row">
                <div className="col-lg-12 text-center" style={{ position: "relative" }}>
                  <div className="pagination pagi">
                    {currentPage === 1 ? "" : <a href="javascript:void(0)" onClick={prevPage} disabled={currentPage === 1}>&laquo;</a>}

                    {Array.from({ length: Math.ceil(order.length / itemsPerPage) }).map((_, index) => (
                      <a href="javascript:void(0)" key={index}
                        onClick={() => goToPage(index + 1)}
                        className={currentPage === index + 1 ? "active" : ""}>{index + 1}</a>
                    ))}
                    {currentPage === Math.ceil(order.length / itemsPerPage) ? "" : <a href="javascript:void(0)" onClick={nextPage}
                      disabled={currentPage === Math.ceil(order.length / itemsPerPage)}>&raquo;</a>}

                  </div>
                  <div className="table-no-count">
                    Showing {Math.min(indexOfLastItem, order.length)} of {order.length} results
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Update Status Modal */}
        <Modal size="lg"
          aria-labelledby="contained-modal-title-vcenter" show={updateStatusModal} onHide={handleCloseUpdateStatus} centered>
          <Modal.Header closeButton>
            <Modal.Title>Update Order Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group mb-3">
              <label>Order ID:</label>
              <input type="text" className="form-control" value={selectedOrderId || ''} readOnly />
            </div>
            <div className="form-group mb-3">
              <label>Select New Status:</label>
              <select className="form-control" value={selectedOrderStatus} onChange={e => setSelectedOrderStatus(e.target.value)}>
                <option value="">Select Status</option>
                <option value="RTO">RTO</option>
                <option value="Delivered">Delivered</option>
              </select>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-secondary" onClick={handleCloseUpdateStatus} disabled={statusUpdating}>Cancel</button>
            <button className="btn btn-success" onClick={handleSubmitStatusUpdate} disabled={statusUpdating || !selectedOrderStatus}>
              {statusUpdating ? 'Updating...' : 'Submit'}
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={modalShow1}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header style={{ padding: "0px" }}>

            <div className="title m-0 p-0">
              <h3 className="p-3">Filters</h3>
            </div>
          </Modal.Header>
          <Modal.Body>
            <form className="mt-3 p-3">
              <div className="filter-dt p-2">
                <div className="input-box">
                  <span className="details">Start Date</span>
                  <input type="date" className="form-control" placeholder="dd/mm/yyyy" required value={startDate} onChange={(e) => {
                    setstartDate(e.target.value)
                  }} />
                </div>
                <div className="input-box">
                  <span className="details">End Date</span>
                  <input type="date" className="form-control" placeholder="dd/mm/yyyy" required value={endDate} onChange={(e) => {
                    setendDate(e.target.value)
                  }} />
                </div>
                <div className="input-box">
                  <span className="details">Start Time</span>
                  <input type="time" className="form-control" placeholder="12:46 AM" required value={startTime} onChange={(e) => {
                    setstartTime(e.target.value)

                  }} />
                </div>
                <div className="input-box">
                  <span className="details">End Time</span>
                  <input type="time" className="form-control" placeholder="12:46AM" required value={endTime} onChange={(e) => {
                    setendTime(e.target.value)

                  }} />
                </div>
                <div className="payment-method mb-2">
                  <div className="details m-1">Payment Mode</div>
                  <select className="form-control p-2" value={paymentMode} onChange={(e) => {
                    setpaymentMode(e.target.value)
                  }}>
                    <option value={""}>Payment Type</option>
                    <option value={"COD"}><div className="check-box p-1">
                      <input type="checkbox" />
                      <label for="">COD</label>
                    </div></option>
                    <option value={"Prepaid"}><div className="check-box p-1">
                      <input type="checkbox" />
                      <label for="">Prepaid</label>
                    </div></option>
                  </select>


                </div>

              </div>
            </form>
            <div className="buton mb-3 d-flex align-content-end justify-content-end p-3 pl-5">
              <button className="btn1" onClick={() => {
                setModalShow1(false);
                getreceivedorder();
                setstartDate("");
                setendDate("");
                setstartTime("");
                setendTime("");
                setpaymentMode("");

              }}>Cancel</button> &nbsp;&nbsp;
              <button className="btn2 " onClick={() => {
                filter()
              }}>Apply</button>
            </div>



          </Modal.Body>

        </Modal>
        <Modal
          show={modalShow2}
          size="lg"
          scrollable={true}
          fullscreen={true}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >

          <Modal.Body style={{ display: "flex", justifyContent: "center", backgroundColor: "rgb(226, 226, 226)" }} id="invoiceprint">
            {order.length > 0 ?
              <div className='invoice'>
                <div className="invoice-box ">

                  <div className="invoice-head">
                    <div className="color-logo">
                      <img src="assets/Colorbot_INVOICE/COLORBOT-R-logo.png" alt="" />
                    </div>
                    <div className="color-logo-txt">
                      <p><b>TAX INVOICE</b></p>
                      ORIGINAL FOR CUSTOMER
                    </div>

                  </div>


                  <table className="compny-address" style={{ width: "100%" }}>
                    <tr>
                      <th></th>
                      <th></th>

                    </tr>
                    <tr>
                      <td className="tble-left">


                        <div className="compny-add">
                          <p className="sol">Sold by:</p>
                          <p className="address"> <b>Colorbot Private Limited</b> <br />
                            03/UG-29, UPPER GROUND
                            FLOOR, ANSAL PLAZA, SECTOR-1, VAISHALI,
                            GHAZIABAD-201010 (U.P.)
                          </p>
                        </div>
                        <div className="gtin">
                          <span>GSTIN : </span>
                          <span>09AAKCC5866H1Z6</span>
                        </div>
                        <div className="gtin">
                          <span>PAN : </span>
                          <span>AAKCC5866H</span>
                        </div>
                        <br />


                        <div className="invoice-no">
                          <span>Invoice No : </span>
                          <span>{order[id]?.InvoiceNumber}</span>
                        </div>
                        <div className="invoice-no">
                          <span>Invoice Date :</span>
                          <span>{order[id].OrderDate.split(" ")[0]}</span>
                        </div>

                      </td>

                      <td className="tble-left tble-rght">
                        <div className="invoice-no">
                          <span>Order ID : </span>
                          <span>{order[id].OrderId}</span>
                        </div>
                        <div className="invoice-no">
                          <span>Order Date:</span>
                          <span>{order[id].OrderDate.split(" ")[0]}</span>
                        </div>

                      </td>
                    </tr>
                  </table>

                  <table className="compny-address" style={{ width: "100%" }}>
                    <tr>
                      <th></th>
                      <th></th>

                    </tr>
                    <tr>
                      <td className="tble-left">
                        <div className="compny-add">
                          <p className="sol">Bill To :</p>

                          <p className="address"> <b>{order[id].OrderGST !== "NA" ? order[id].OrderGSTBussinessName : <> {order[id].OrderAddress?.[0]?.FirstName} {order[id].OrderAddress?.[0]?.LastName}</>}</b> <br />
                            {order[id].OrderAddress?.[0]?.Address} {order[id].OrderAddress?.[0]?.Address1}<p></p>
                            {order[id].OrderAddress?.[0]?.City} {order[id].OrderAddress?.[0]?.State}<p></p>
                            {order[id].OrderAddress?.[0]?.Pincode} IN
                          </p>
                        </div>

                        <div className="gtin input-widt">
                          <span>State/UT Name : </span>
                          <span>{getCodeByStateName(order[id].OrderAddress?.[0]?.State.toUpperCase())}</span>
                        </div>
                        <div className="gtin">
                          <span>GSTIN : </span>
                          <span>{order[id].OrderGST}</span>
                        </div>

                      </td>

                      <td className="tble-left tble-rght">
                        <div className="compny-add">
                          <p className="sol">Ship To :</p>
                          <p className="address"> <b>{order[id].OrderAddress?.[0]?.FirstName} {order[id].OrderAddress?.[0]?.LastName}</b> <br />
                            {order[id].OrderAddress?.[0]?.Address} {order[id].OrderAddress?.[0]?.Address1}<p></p>
                            {order[id].OrderAddress?.[0]?.City} {order[id].OrderAddress?.[0]?.State}<p></p>
                            {order[id].OrderAddress?.[0]?.Pincode} IN
                          </p>
                        </div>
                        {/* <div className="gtin input-widt">
                        <span>State/UT Name : </span>
                        <span>09</span>
                      </div> */}
                      </td>
                    </tr>
                  </table>

                  <table className="invoice-details" style={{ width: "100%" }}>
                    <tr className="t-head">
                      <th>S. No.</th>
                      <th>Item Code</th>
                      <th>Item Description</th>
                      <th>HSN No.</th>

                      <th>Qty</th>
                      <th>Amount <br /> <span>(exclusive of GST)</span></th>
                    </tr>
                    {order[id].OrderDetail.length > 0 && order[id].OrderDetail.map((item, index) => {
                      return (
                        <tr className="t-body" key={index}>
                          <td>{index + 1}</td>
                          <td>{item.OrderItemId}</td>
                          <td>{item.OrderName?.slice(0, 20) + "...."} | {item.OrderColor} | {item.OrderSize}</td>
                          <td>{getHsCode(item)}</td>

                          <td>{item.OrderQuantity}</td>
                          <td>{(Number(item.OrderSubTotal) / 1.18).toFixed(2)}</td>
                        </tr>
                      )
                    })
                    }

                  </table>

                  <table className="tax-detail" style={{ width: "100%" }}>
                    <tr>
                      <th></th>
                    </tr>

                    <tr>
                      <td> <b>Total Amount </b>(exclusive of GST) </td>

                      <td></td>
                      <td>{(Number(invoice?.totalamount) / 1.18).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td> <b>Warranty </b>(exclusive of GST) </td>

                      <td></td>
                      <td>0</td>
                    </tr>
                    <tr>
                      <td> <b>Shipping </b>(exclusive of GST) </td>

                      <td></td>
                      <td>0</td>
                    </tr>
                    <tr>
                      <td> <b>Discount (coupon) </b>(exclusive of GST) </td>

                      <td></td>
                      <td>{(Number(order[id]?.OrderCoupanPrice) / 1.18).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td> <b>Subtotal </b>(exclusive of GST) </td>

                      <td></td>
                      <td>{((Number(invoice?.totalamount) - Number(order[id]?.OrderCoupanPrice)) / 1.18).toFixed(2)}</td>
                    </tr>

                    <tr>

                      <td></td>
                      <td> <b>Tax Rate: </b><br />
                        {order[id].OrderAddress?.[0]?.State === "Uttar Pradesh" ? " CGST 9%" : "IGST 18%"}
                        {order[id].OrderAddress?.[0]?.State === "Uttar Pradesh" ? <br /> : ""}
                        {order[id].OrderAddress?.[0]?.State === "Uttar Pradesh" ? "SGST 9%" : ""}
                      </td>
                      <td style={{ paddingTop: "22px" }}>

                        {order[id].OrderAddress?.[0]?.State === "Uttar Pradesh" ? (calculateTaxAmount(invoice, order, id) / 2).toFixed(2) : ""}
                        {order[id].OrderAddress?.[0]?.State === "Uttar Pradesh" ? <br /> : ""}
                        {order[id].OrderAddress?.[0]?.State === "Uttar Pradesh" ? (calculateTaxAmount(invoice, order, id) / 2).toFixed(2) : calculateTaxAmount(invoice, order, id).toFixed(2)}
                      </td>
                    </tr>

                    <tr>
                      <td><b>Payable amount</b></td>

                      <td></td>

                      <td className="pay-amnt"> <b>Rs. {calculateFinalAmount(invoice, order, id)}</b>
                      </td>
                    </tr>
                  </table>

                  <table className="signature" style={{ width: "100%" }}>
                    <tr>
                      <th></th>
                      <th></th>
                    </tr>
                    <tr>
                      <td className="word-amnt">Amount in Words: <br />
                        {invoice?.totalamount > 0 ? toWords.convert(calculateFinalAmount(invoice, order, id), { currency: true }) : ""}
                      </td>
                      <td className="sign-stmp"> For Colorbot Pvt. Ltd. <br />
                        Authorized Signatory <br />
                        <img src="assets/Colorbot_INVOICE/invoice-sign.png" alt="" />
                        <img src="assets/Colorbot_INVOICE/stamp-dummy.png" alt="" />
                      </td>
                    </tr>
                  </table>

                  <table className="invoice-tc" style={{ width: "100%" }}>
                    <tr>
                      <th></th>
                    </tr>

                    <tr>
                      <td>
                        <div className="text-cont">
                          <h6>Whether tax is payable under reverse charge - No</h6>
                          <p>Declaration: This invoice declares that this invoice shows the actual price of the goods
                            described and
                            that all particulars are true and correct</p>
                          <ul>
                            <li>Disputes or complaints if any, must be intimated within 3 days in writing and shall be
                              referred to
                              Colorbot Pvt Ltd. 03/UG-29, UPPER GROUND FLOOR, ANSAL PLAZA, SECTOR-1, VAISHALI,
                              GHAZIABAD-201010
                              (U.P.)</li>
                            <li>Invoice shall be deemed accepted if any dispute is not raised within 3 days of invoice
                              delivery over
                              email.</li>
                            <li>TRAI rules shall be applicable at all times for SMS and Voice services.</li>
                            <li>WhatApp rules and policies shall be applicable for WhatsApp services.</li>
                            <li>Keep the Invoice and manufacturer box for warranty purposes.</li>
                            <li>For any concerns or feedback,please contact us at support@colorbot.in.</li>
                            <li>Please visit our website www.colorbot.in for more details/information</li>
                            <li>This is an electronicaly generated invoice</li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  </table>

                  <table className="last-row" style={{ width: "100%" }}>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>

                    <tr>
                      <td> <span><b>Invoice Amount</b> </span> <br />

                        <span>Rs. {calculateFinalAmount(invoice, order, id)}  /-</span>
                      </td>
                      <td> <span><b>Invoice Date</b> </span> <br />
                        <span>{order[id].OrderDate.split(" ")[0]}</span>
                      </td>
                      <td><span><b>Payment Mode</b> </span> <br />
                        <span>{order[id].OrderPaymentType}</span>
                      </td>
                    </tr>
                  </table>

                </div>
              </div> : ""}



          </Modal.Body>
          <Modal.Footer >
            <div className="buton  d-flex align-content-end justify-content-end ">
              <button className="btn1" onClick={() => {
                setModalShow2(false);


              }}>Cancel</button> &nbsp;&nbsp;
              <button className="btn2 " onClick={() => {
                print()
              }}>Print</button>
            </div>
          </Modal.Footer>

        </Modal>
        <Modal
          show={modalShow3}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header style={{ padding: "0px" }}>
            <div className="topbar">
              <div className="col-lg-12 p-3 d-flex justify-content-center" style={{
                position: "relative"

              }}>

                <h4>{userData?.UserData?.FirstName} {userData?.UserData?.LastName}</h4>


                <img src="assets/cross.svg" style={{ cursor: "pointer", position: "absolute", right: "14px" }} alt="" onClick={() => {
                  setModalShow3(false)
                }} />

              </div>
            </div>

          </Modal.Header>
          <Modal.Body>


            <div className="row inner-cntnt p-4">
              <form className='pb-2'>
                <label className="form-label">Phone </label>

                <textarea type="text" className="form-control" value={userData?.UserData?.Phone} style={{ height: "50px", paddingTop: "10px", backgroundColor:"transparent" }} readOnly  />



              </form>
              <form className='pb-2'>
                <label className="form-label">Email </label>

                <textarea type="text" className="form-control" value={userData?.UserData?.Email} style={{ height: "50px", paddingTop: "10px", backgroundColor:"transparent" }} readOnly />



              </form>

              <form >
                <label className="form-label">Address </label>
                {userData?.UserData?.Address.length > 0 && userData?.UserData?.Address.map((item, index) => {
                  var value = `${item.Address} ${item.Address1}, ${item.City}, ${item.State}. ${item.Pincode}`
                  return (
                    <div className="mb-3 col-12 " key={index} style={{ position: "relative" }}>

                      <textarea type="text" className="form-control" value={value} style={{ height: "100px", backgroundColor:"transparent" }} readOnly />
                      <span style={{ color: "lightgray", fontSize: "10px", position: "absolute", right: "-4rem", top: "5rem" }}>({item.AddressType})</span>
                    </div>
                  )

                })}

              </form>
            </div>
            <hr />
            <div className="row inner-cntnt  p-4 pt-2 pb-0">
              <form >
                <label className="form-label">Previously Ordered </label>

                <div className="mb-3 col-12 " key={index} style={{ position: "relative" }}>

                  <textarea
                    type="text"
                    className="form-control"
                    value={
                      userData?.OrderData?.length > 0 &&
                      userData?.OrderData
                        ?.map((item, index) => `${index + 1}. ${item.OrderId}`)
                        .join('\n')
                    }
                    style={{ minHeight: "100px", overflowY: "auto", backgroundColor:"transparent" }}
                    readOnly
                  ></textarea>


                </div>

              </form>
            </div>

          </Modal.Body>

        </Modal>
        <Modal
          show={modalShow4}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header style={{ padding: "0px" }}>
            <div className="topbar">
              <div className="col-lg-12 p-3 d-flex justify-content-center" style={{
                position: "relative"

              }}>

                <h4>{orderData?.OrderData?.OrderId}</h4>


                <img src="assets/cross.svg" style={{ cursor: "pointer", position: "absolute", right: "14px" }} alt="" onClick={() => {
                  setModalShow4(false)
                }} />

              </div>
            </div>

          </Modal.Header>
          <Modal.Body>

            <div className="row mt-1 p-4">
              {/* Filter products for regular items (not LED bulbs or geysers) */}
              {orderData?.OrderData?.OrderDetail?.some(item => 
                !item.OrderName?.toLowerCase().includes('led bulb') && 
                !item.OrderName?.toLowerCase().includes('geyser')
              ) && (
                <div className="col-lg-12 table-bg ">
                  <h5 className="p-1 text-center">Fans</h5>
                  <div className="table-responsive p-1">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th scope="col">S.No.</th>
                          <th scope="col">Item No</th>
                          <th scope="col">Product Name</th>
                          <th scope="col">Quantity</th>
                          <th scope="col">Colour</th>
                          <th scope="col">Sweep Sizes</th>
                          <th scope="col">Price</th>
                          <th scope="col">Warranty</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orderData?.OrderData?.OrderDetail?.filter(item => 
                          !item.OrderName?.toLowerCase().includes('led bulb') && 
                          !item.OrderName?.toLowerCase().includes('geyser')
                        ).map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.OrderItemId}</td>
                            <td>{item.OrderName} </td>
                            <td>{item.OrderQuantity}</td>
                            <td>{item.OrderColor}</td>
                            <td>{item.OrderSize}</td>
                            <td>Rs.{item.OrderSubTotal}</td>
                            <td>{item.OrderExtendedWarranty?item.OrderName.toLowerCase().includes("exhaust fan")?daysLeftToNextThreeYearsFromDate(orderData?.OrderData?.createdAt)>0?daysLeftToNextThreeYearsFromDate(orderData?.OrderData?.createdAt) + " days":"Expired":daysLeftToNextTwoYearsFromDate(orderData?.OrderData?.createdAt) > 0 ? daysLeftToNextTwoYearsFromDate(orderData?.OrderData?.createdAt) + " days" : "Expired":""} </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              
              {/* Filter products for LED bulbs */}
              {orderData?.OrderData?.OrderDetail?.some(item => 
                item.OrderName?.toLowerCase().includes('led bulb')
              ) && (
                <div className="col-lg-12 table-bg mt-1">
                  <h5 className="p-1 text-center">LED Bulbs</h5>
                  <div className="table-responsive p-1">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th scope="col">S.No.</th>
                          <th scope="col">Item No</th>
                          <th scope="col">Product Name</th>
                          <th scope="col">Quantity</th>
                          <th scope="col">Pack Of</th>
                          <th scope="col">Power Consumption</th>
                          <th scope="col">Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orderData?.OrderData?.OrderDetail?.filter(item => 
                          item.OrderName?.toLowerCase().includes('led bulb')
                        ).map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.OrderItemId}</td>
                            <td>{item.OrderName} </td>
                            <td>{item.OrderQuantity}</td>
                            <td>{item.OrderColor}</td>
                            <td>{item.OrderSize}</td>
                            <td>Rs.{item.OrderSubTotal}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              
              {/* Filter products for geysers */}
              {orderData?.OrderData?.OrderDetail?.some(item => 
                item.OrderName?.toLowerCase().includes('geyser')
              ) && (
                <div className="col-lg-12 table-bg mt-4">
                  <h5 className="p-2">Geysers</h5>
                  <div className="table-responsive p-3">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th scope="col">S.No.</th>
                          <th scope="col">Item No</th>
                          <th scope="col">Product Name</th>
                          <th scope="col">Quantity</th>
                          <th scope="col">Colour</th>
                          <th scope="col">Capacity</th>
                          <th scope="col">Price</th>
                          {/* <th scope="col">Warranty</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {orderData?.OrderData?.OrderDetail?.filter(item => 
                          item.OrderName?.toLowerCase().includes('geyser')
                        ).map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.OrderItemId}</td>
                            <td>{item.OrderName} </td>
                            <td>{item.OrderQuantity}</td>
                            <td>{item.OrderColor}</td>
                            <td>{item.OrderSize}</td>
                            <td>Rs.{item.OrderSubTotal}</td>
                            {/* <td>{item.OrderExtendedWarranty ? daysLeftToNextTwoYearsFromDate(orderData?.OrderData?.createdAt) : ""}</td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>

          </Modal.Body>

        </Modal>




      </section>
    </>
  )
}
export default Ordermgmt;